var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 3.79086 4.79086 2 7 2H20.3333C20.8384 2 21.3 2.28534 21.5259 2.73705C21.7518 3.18876 21.703 3.72931 21.4 4.13333L18 8.66667L21.4 13.2C21.703 13.604 21.7518 14.1446 21.5259 14.5963C21.3 15.048 20.8384 15.3333 20.3333 15.3333H7C6.26362 15.3333 5.66667 15.9303 5.66667 16.6667V20.6667C5.66667 21.403 5.06971 22 4.33333 22C3.59695 22 3 21.403 3 20.6667V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.2ffedeca48901b8bb2d23bf784388881.svg";
export { ForwardRef as ReactComponent };